import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import UserModel from '../../models/UserModel';
import Swal from "sweetalert2";

const validationSchema = Yup.object().shape({
  old_password: Yup.string().required('Vui lòng nhập mật khẩu cũ'),
  new_password: Yup.string().required('Vui lòng nhập mật khẩu mới').min(6, 'Mật khẩu tối thiểu 6 ký tự'),
  confirm_password: Yup.string().required('Vui lòng xác nhận mật khẩu').oneOf([Yup.ref('new_password')], 'Mật khẩu không khớp')
});

function ModalChangePassword(props) {
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    UserModel.changePassword({
      type: "PASSWORD",
      old_password: values.old_password,
      new_password: values.new_password,
      repeat_password: values.confirm_password
    }).then(res => {
      if (res.success) {
        Swal.fire({ icon: "success", title: "Đổi mật khẩu thành công!", timer: 2000, showConfirmButton: false });
        resetForm();
        props.onHide();
      } else {
        Swal.fire({ icon: "error", title: res.message || "Đổi mật khẩu thất bại!", timer: 2000, showConfirmButton: false });
      }
    }).catch(err => {
      Swal.fire({ icon: "error", title: err.response?.data?.message || "Đổi mật khẩu thất bại!", timer: 2000, showConfirmButton: false });
    }).finally(() => setSubmitting(false));
  };

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Đổi mật khẩu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          initialValues={{ old_password: '', new_password: '', confirm_password: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="mb-3">
                <label className="form-label">Mật khẩu cũ</label>
                <Field type="password" name="old_password" className="form-control" />
                <ErrorMessage name="old_password" component="div" className="text-danger" />
              </div>
              <div className="mb-3">
                <label className="form-label">Mật khẩu mới</label>
                <Field type="password" name="new_password" className="form-control" />
                <ErrorMessage name="new_password" component="div" className="text-danger" />
              </div>
              <div className="mb-3">
                <label className="form-label">Xác nhận mật khẩu mới</label>
                <Field type="password" name="confirm_password" className="form-control" />
                <ErrorMessage name="confirm_password" component="div" className="text-danger" />
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                {isSubmitting ? 'Đang xử lý...' : 'Đổi mật khẩu'}
              </button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default ModalChangePassword;
